import React from "react";

const ContextForm = React.createContext();

export default ContextForm;
